<template>
	<div class='pt-0.5'>
		<div class='py-2 flex items-center justify-between curor-pointer icon-hover px-6' @click='open = !open'>
			<h5 class='font-bold text-20'>{{ title }}</h5>

			<div class='w-10 h-12 flex items-center justify-center'>
				<IconArrowDown
					class='transition-transform w-4.5 h-4.5'
					:class='[
						{"rotate-180": open},
					]'
				/>
			</div>
		</div>

		<div>
			<TransitionHeight ref='menu'
				:visable='open'
				class='border-b border-grey-500'
			>
				<slot />
			</TransitionHeight>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			title: String,
			loadOpen: {
				type: Boolean,
				default: false
			}
		},

		mounted() {
			if (this.loadOpen) {
				this.open = true
			}
		},

		data() {
			return {
				open: false
			}
		}
	}
</script>